module.exports = __webpack_public_path__ + "img/law4m-m@1.0feb8e51.webp";